import { render } from "./addReturns.vue?vue&type=template&id=67c2e901&scoped=true"
import script from "./addReturns.vue?vue&type=script&lang=js"
export * from "./addReturns.vue?vue&type=script&lang=js"

import "./addReturns.vue?vue&type=style&index=0&id=67c2e901&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-67c2e901"

export default script